
        import 'MoreInfo.01a1610.css-module'
        export default {"moreInfoModal":"moreInfoModal_MoreInfo_01a1610"}
    